<template>
    <div class="server_selected" v-if="selected.length>0">
        <a-divider dashed style="margin:15px 0;"/>
        <div>
            已选服务器：
            <a-tag closable @close="closeServer(server.id)" @click="closeServer(server.id)" v-for="server in selected" :key="server.id">{{server.name}}</a-tag>
        </div>
    </div>
</template>

<script>
import {Tag, Divider} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Tag)
Vue.use(Divider)

export default {
    props:['value'],
    computed: {
        servers() {
            let servers = this.$store.state.game.servers
            return _.concat(servers["online"]?servers["online"]:{}, servers["hefu"]?servers["hefu"]:{})
        },
        selected() {
            let val = this.value?this.value:[]
            let selected = _.filter(this.servers, (s)=>val.indexOf(s.id)>=0)
            return selected
        },
    },
    methods: {
        closeServer(id) {
            let index = this.value.indexOf(id)
            if(index>=0) {
                this.value.splice(index,1)
                this.$emit('input', this.value)
            }
        },
    }
}
</script>